// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1j8ju","paramInput":"JobSimulator_paramInput__2TzSl","input":"JobSimulator_input__28j-0"};